import { render, staticRenderFns } from "./AddSurveyTextDialog.vue?vue&type=template&id=38e66314"
import script from "./AddSurveyTextDialog.vue?vue&type=script&lang=js"
export * from "./AddSurveyTextDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports